module.exports = __webpack_public_path__ + "img/net-banking-pg.1b393db3.svg";